import * as React from 'react'
import Image from 'gatsby-image'
import TestimonialsCarousel from '../TestimonialsCarousel'
import testimonials from '../../data/testimonials'

import s from './styles.module.css'

export default class Reviews extends React.PureComponent {
  render() {
    const { title, image } = this.props

    return (
      <section className={s.testimonials}>
        <Image
          outerWrapperClassName={s.testimonialsImageWrapper}
          className={s.testimonialsImage}
          sizes={image.sizes}
          alt={title}
        />
        <h1 className={s.testimonialsTitle}>{title}</h1>
        <TestimonialsCarousel testimonials={testimonials} />
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Reviews/index.js